import React from 'react';
import Arrow from '../assets/icons/Arrow';

const ButtonSection = ({ width, height, borderColor, backgroundColor, text, onClick }) => {
  return (
    <div style={{ ...styles.buttonWrapper, width, height }}>
      <div style={{
        ...styles.highlight,
        width,
        height,
        borderColor
      }} />
      <div style={{ ...styles.buttonBox, width, height }}>
        <button
          style={{ ...styles.ctaButton, width, height, backgroundColor }}
          onClick={onClick}
        >
          <span style={styles.buttonText}>{text}</span>
          <div style={styles.iconContainer}>
            <Arrow />
          </div>
        </button>
      </div>
    </div>
  );
};

export default ButtonSection;

const styles = {
  buttonWrapper: {
    position: 'relative',
    display: 'inline-block',
    zIndex: 2,
  },
  highlight: {
    position: 'absolute',
    top: 10,
    left: 10,
    backgroundColor: 'transparent',
    border: '2px solid',
    borderRadius: 6,
    zIndex: 1,
  },
  buttonBox: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 6,
    zIndex: 2,
  },
  ctaButton: {
    borderRadius: 6,
    alignItems: 'center',
    cursor: 'pointer',
    display: 'inline-flex',
    padding: '20px 30px',
    zIndex: 3,
    border: 'none',
  },
  buttonText: {
    color: '#171718',
    fontWeight: 700,
    fontSize: '32px',
    lineHeight: '32px',
    whiteSpace: 'nowrap',
  },
  iconContainer: {
    marginLeft: 16
  }
};
